import { ExpandOptions } from 'components/CIMSTable/CIMSTableContext/types/expand'
import { ConcreteMixDesign } from '../MixDesignsContext/types'
import { HelpMessage } from 'utils/constants'
import { CIMSTags } from 'components/CIMSTags'
import { useConcreteMixDesignsContext } from '../MixDesignsContext'

export function useExpand(): ExpandOptions<ConcreteMixDesign> {
  const help = HelpMessage.Materials.Concrete
  const { edit, refetch } = useConcreteMixDesignsContext()

  return {
    expandable: ({
      wc,
      airRange,
      slumpRange,
      admixtures,
      maxAggSize,
      aggregates,
    }) => {
      return (
        !!wc ||
        !!airRange ||
        !!slumpRange ||
        !!admixtures ||
        !!maxAggSize ||
        !!aggregates.length
      )
    },
    render: ({
      active,
      globalId,
      wc,
      airRange,
      slumpRange,
      admixtures,
      maxAggSize,
      aggregates,
      customFields,
    }) => ({
      additionalInfo: [
        {
          label: 'W/C Ratio',
          children: wc,
          help: help.WC,
        },
        {
          label: 'Air Range',
          children: airRange,
          help: help.Air,
        },
        {
          label: 'Slump Range',
          children: slumpRange,
          help: help.Slump,
        },
        {
          label: 'Admixtures',
          children: admixtures,
          help: help.Admixtures,
        },
        {
          label: 'Max Agg Size',
          children: maxAggSize,
          help: help.MaxAggSize,
        },
        {
          label: 'Aggregates',
          children: (
            <CIMSTags
              tags={aggregates.map((aggregate) => ({ text: aggregate }))}
            />
          ),
          help: help.Aggregates,
        },
      ],
      customFields: {
        customFields,
        alreadyDisabled: false,
        recordInactive: !active,
        booleanValueOptions: {
          onCheck: async (input) => {
            await edit({
              variables: {
                input: {
                  globalId,
                  customFields: { booleanInputs: [input] },
                },
              },
            })
            refetch()
          },
        },
        listValueOptions: {
          onCheck: async (input) => {
            await edit({
              variables: {
                input: {
                  globalId,
                  customFields: { listInputs: { checkboxes: [input] } },
                },
              },
            })
            refetch()
          },
        },
      },
    }),
  }
}
